// --- REAL PROD CONFIG FOR CIRCLE BUILDS ---
export const environment = {
  app: 'employer',
  production: true,
  sentryDsn: 'https://d07239019f6f470c9c108cfd9c397766@o31306.ingest.sentry.io/5397074',
  adyenClientKey: 'live_RPJIAQ2P6RD7PFLJMCIEHFWAPQW2EUQ3',
  enableTopNav: "true",
  enableProfile: false,
  interviewPhoneNumber: "1-844-931-1907",
  rootCookieDomain: '.snagajob.com',
  jobSeekerWebUrl: 'https://www.snagajob.com',
  marketplaceUrl: 'https://employer.snagajob.com',
  dynamicLinkBaseUrl: 'https://snagajob.page.link',
  careerPagesEdgeUrl: 'https://career-sites.snagajob.com/api-edge',
  domain: 'snagprod.corp',
  circleBuildNum: '33415',
  circleSha: '7ea75810b27e52e2ef8cc8ea50b9edc50d3bcb56',
  branch: 'master',
  sentryReleaseVersion: '7ea75810b27e52e2ef8cc8ea50b9edc50d3bcb56',
  tag: '',
  pactSafeUrl: 'https://vault.pactsafe.io/s/7fe9b7ef-16d8-4a62-85dc-95e1f0d0568f/legal.html?g=27766',
  pactSafeEnabled: 'true',
  enablePWA: true,
  enableMarketingPreference: true,
  enableDownloadAppLandingPage: false,
  turnstileSiteKey: '0x4AAAAAAAY2C68jq7zAOAln',
  turnstileScriptUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
};
